import React from 'react';
import { Container } from '@/Components/ui/container';

function Header() {
  return (
    <header className="flex items-center justify-center py-4">
      <Container>
        <img 
          src="/Newzenalphablue.png" 
          alt="Company Logo" 
          className="h-12 w-auto"
        />
      </Container>
    </header>
  );
}

export default Header;